<template>
	<v-container grid-list-xl>
		<v-layout row wrap>          
			<v-flex lg12 class="userInfo">               
              <v-data-table :search="search" :items="quoteItems" class="elevation-1 middleTable" style="font-size: 10px;" hide-actions>               
                <template slot="headers" slot-scope="props">
                  <tr class="middle">
                    <th colspan="2">ITEM</th>
                    <th colspan="2">QUANTITY</th>
                    <th>UOM</th>
                    <th colspan="3">UNIT COSTS</th>
                    <th>GROSS</th>
                    <th>DISCOUNT</th>
                    <th>NETT</th>
                  </tr>
                  <tr class="smaller middle">
                    <th colspan="2">Item</th>
                    <th>Requested</th>
                    <th>Actual</th>
                    <th>Uom</th>
                    <th>Gross</th>
                    <th>Discount</th>
                    <th>Nett</th>
                    <th>Total</th>
                    <th>Total</th>
                    <th>Total</th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td><v-switch @change="fncAddSelectedTotal(props.item.price, props.item.winning)" v-model="props.item.winning"></v-switch></td>
                  <td width="20%" class="text-xs-right">{{ fncFilterName(props.item.name) }}</td>
                  <td class="text-xs-right">{{ props.item.quantity }}</td>
                  <td class="text-xs-right">{{ props.item.quantity_calc }}</td>
                  <td class="text-xs-right">{{ fncFilterName(props.item.uom) }}</td>
                  <td class="text-xs-right">{{ fncFilterPrice(props.item.price) }}</td>
                  <td class="text-xs-right">{{ fncFilterPrice(props.item.discount) }}</td>
                  <td class="text-xs-right">{{ fncFormatNett(props.item.price, props.item.discount) }}</td>
                  <td class="text-xs-right">{{ fncFormatTotal(props.item.price, props.item.quantity_calc) }}</td>
                  <td class="text-xs-right">{{ fncFormatTotal(props.item.discount,props.item.quantity) }}</td>
                  <td class="text-xs-right">{{ fncFormatTotalNett(props.item.price, props.item.quantity_calc, props.item.discount, props.index) }}</td>                  
                </template>                            
              </v-data-table>
              <v-data-table class="elevation-1 hideTable" :items="emptyItems" style="font-size: 10px;" hide-actions>
                <template slot="headers" slot-scope="props">                  
                  <tr class="smaller middle" style="border: none;">                    
                    <th style="font-size: 12px; text-align: right !important; padding: 2% !important" colspan="10">
                      <strong>NETT TOTAL</strong>: <strong>{{ fncFilterPrice(totalNett) }}</strong><br /><br />
                      <strong>VAT @ 15%</strong>: <strong>{{ fncCalculateVat() }}</strong><br /><br />
                      <strong>TOTAL</strong>: <strong>{{ fncFinalTotal() }}</strong><br /><br /><br />
                      <strong>SELECTED TOTAL</strong>: <strong>{{ fncSelectedTotal() }}</strong>
                    </th>
                  </tr>                  
                </template>
              </v-data-table>
			</v-flex>		
			<div class="pl-4 pr-4 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>		
                    <v-btn color="success" class="text-xs-right" :disabled="totalSelected == 0" @click.stop="fncUpdateProjectQuote">Update</v-btn>
                    <small>* The button will activate once all required fields have been completed</small>
				</div>
			</div>						
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
        return {              
              objUser: 0,
              search: '',
              totalNett: 0,
              totalVat: 0,
              totalSelected: 0,
              emptyItems: [],
              quoteItems: this.$store.getters.projectTenderWinner.content
			};
		},		
      methods: {
            fncFilterName(name) {
              var dataUrl = name.replace(/%20/g, " ");
              dataUrl = dataUrl.replace(/%27/g, "'");
              dataUrl = dataUrl.replace(/%3A/g, ":");
              dataUrl = dataUrl.replace(/%3B/g, ";");
              dataUrl = dataUrl.replace(/%3C/g, "<");
              dataUrl = dataUrl.replace(/%3D/g, "=");
              dataUrl = dataUrl.replace(/%3E/g, ">");
              dataUrl = dataUrl.replace(/%2C/g, ",");
              dataUrl = dataUrl.replace(/%28/g, "(");
              dataUrl = dataUrl.replace(/%29/g, ")");
              dataUrl = dataUrl.replace(/&sup/g, "");
              dataUrl = dataUrl.replace(/;/g, "");
              
              return dataUrl;
            },
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncFilterPrice(filterVar) {
              var currencyValue = parseFloat(filterVar).toFixed(2);
              currencyValue = currencyValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + currencyValue;
            },
            fncFormatPerc(filterDiscount, ) {
              return parseFloat(filterVar).toFixed(2) + '%';
            },
            fncFormatNett(filterPrice, filterDiscount) {              
              var finalPrice = parseFloat( parseFloat(filterPrice) - parseFloat(filterDiscount) ).toFixed(2);
              var nettValue = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + nettValue;
            },
            fncFormatTotal(filterPrice, filterQty) {
              var finalPrice = filterPrice * filterQty;
                  finalPrice = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + finalPrice;
            },
            fncFormatTotalNett(filterPrice, filterQty, filterDiscount, i) {              
              var finalPrice = parseFloat(parseFloat(filterPrice) - parseFloat(filterDiscount)).toFixed(2) * filterQty;
              var nettValue = finalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");    
              var oldNett = this.totalNett;
              /*oldNett += finalPrice;              
              this.totalNett = oldNett;*/
              //this.totalNett = this.totalNett + 1000;
              return 'R' + nettValue;
            },
            fncCalculateVat() {              
              var totalVat = parseFloat(this.totalNett * 0.14).toFixed(2);
              this.totalVat = totalVat;
                  totalVat = totalVat.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + totalVat;
            },
            fncFinalTotal() {
              var finalTotal = parseFloat(parseFloat(this.totalNett) + parseFloat(this.totalVat)).toFixed(2);
              finalTotal = finalTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return 'R' + finalTotal;
            },
            fncSelectedTotal() {
              return 'R' + this.totalSelected.toFixed(2);
            },
            fncUpdateProjectQuote() {              
              this.$store.dispatch({
                type: 'fncUpdateProjectQuote',
                projectId: this.globalModalParams.projectId,
                items: this.quoteItems
              })              
            },
            fncAddSelectedTotal(price, status) {
              if ( status == true ) {
                this.totalSelected += parseFloat(price);
              } else {
                this.totalSelected -= parseFloat(price);
              }
              return totalSelected.toFixed(2);
            }
		},
		computed: {
			...mapGetters([			
				'objAuthorize',							
				'globalModalParams',
				'projectTenderWinner'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>